import React from 'react';
import { Tabs, TabContent } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import { shouldDisableLegacyReports, shouldShowMerchants, shouldShowTableauReports } from 'Selectors';
import { configService } from 'Services';
import queryString from 'query-string';
import { useLocation } from 'react-router-dom';
import appStyles from 'Routes/Routes.css';
import ReportsContainer from './components/ReportsContainer';
import TableauContainer from './components/TableauContainer';
import Header from './components/Header';
import styles from './Reports.css';

const Reports = () => {
    const { t } = useTranslation();
    const { search } = useLocation();
    const { reportType } = queryString.parse(search);
    const reportTypeIndex = reportType === 'performance' ? 1 : 0;
    const summaryTitle = shouldShowMerchants() ? t('Merchant Summary Reports') : t('Transaction Summary Reports');
    const summaryTabTitle = shouldShowMerchants() ? t('Merchant Summary') : t('Transaction Summary');
    const tableauReports = shouldShowTableauReports() ? configService.tableauReports : [];
    const disableLegacyReports = shouldDisableLegacyReports();
    return (
        <div className={appStyles.landingPage}>
            <Header />
            <Tabs className={styles.overridesTabs} startIndex={reportTypeIndex} orientation='vertical' type='small'>
                {!disableLegacyReports && (
                    <TabContent
                        headerTestId='merchant-summary-tab'
                        hidden
                        label={summaryTabTitle}
                        key='merchant-summary-tab'
                    >
                        <ReportsContainer header={summaryTitle} reportType='merchantsummary' />
                    </TabContent>
                )}
                {!disableLegacyReports && (
                    <TabContent
                        headerTestId='rule-performance-tab'
                        hidden
                        label={t('reportTypes.performance')}
                        key='rule-performance-tab'
                    >
                        <ReportsContainer header={t('Rule Performance Reports')} reportType='performance' />
                    </TabContent>
                )}
                {tableauReports.map((report) => {
                    return (
                        <TabContent headerTestId={report.title} hidden label={report.title} key={report.title}>
                            <TableauContainer report={report} />
                        </TabContent>
                    );
                })}
            </Tabs>
        </div>
    );
};

export default Reports;
